import {
  consoleFancyClient,
  extractData,
  type fancyOperations,
  type FancyOk
} from '@frontrow/console/src/open-api/clients'

import {type StoreCategoryT} from '@frontrow/console/src/entities/models/item'

export type ItemParamsT = {
  name: string
  category: string
  storeCategory: StoreCategoryT
  price: number
  isHidden: boolean
  minGrade: number
  maxGrade: number
}

export async function fetchItems(): Promise<FancyOk<fancyOperations['getItemsR']>> {
  return extractData(await consoleFancyClient.GET('/2/items'))
}

export async function patchItem(itemId: number, updateData: ItemParamsT): Promise<unknown> {
  const {data} = await consoleFancyClient.PATCH('/2/items/{ItemP-ItemId}', {
    params: {path: {'ItemP-ItemId': itemId}},
    body: updateData
  })
  return data
}

// The handler answers 201 with the same `ItemGet` that `getItemsR` lists
// (backend/fancy-api/library/Freckle/Api/Handlers/Items.hs:120-126); the spec
// only documents an untyped 200.
export async function postItem(
  itemData: ItemParamsT
): Promise<FancyOk<fancyOperations['getItemsR']>[number]> {
  return extractData(await consoleFancyClient.POST('/2/items', {body: itemData}))
}
